exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"App": "n_ZjjaV048Ohzqg77UafK",
	"App_container": "_3dLjwBkTP6cuCo2IxEkIFt"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/App/style.postcss
// module id = 1199
// module chunks = 0